/* Fine Foams PDP: variant state, add-on upsell, multi-item add-to-cart
   (POSTs to /cart/add.js with Section Rendering so Dawn's cart drawer updates),
   sticky bar, size guide drawer. */
(function () {
  var root = document.querySelector('[data-ff-pdp]');
  if (!root) return;

  var variants = JSON.parse(root.querySelector('[data-ff-variants]').textContent);
  var colourIndex = parseInt(root.dataset.colourIndex, 10); // 1-based, 0 = none
  var sizeIndex = parseInt(root.dataset.sizeIndex, 10);

  var state = {
    colour: initialValue(colourIndex),
    size: initialValue(sizeIndex),
    addon: null
  };

  function initialValue(idx) {
    if (!idx) return null;
    var active = root.querySelector('[data-ff-option][data-option-index="' + idx + '"].is-active');
    return active ? active.dataset.value : null;
  }

  function money(cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-AU', d % 1 === 0
      ? { maximumFractionDigits: 0 }
      : { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function currentVariant() {
    return variants.find(function (v) {
      var okColour = !colourIndex || v['option' + colourIndex] === state.colour;
      var okSize = !sizeIndex || v['option' + sizeIndex] === state.size;
      return okColour && okSize;
    });
  }

  /* Pre-order stamp (22 Oct 2026). The batch the shopper was shown travels
     with the cart line as properties, so the order confirmation email, Shopify
     Flow, Klaviyo and the help desk can tell a pre-order from a stock order.
     _ff_preorder = ISO batch date (hidden: "_" prefix). "Pre-order" is the
     visible label at checkout, on the order status page, in emails and on the
     packing slip. In-stock lines get no properties at all. */
  function preorderProps(variant) {
    if (!variant || !variant.preorder_iso || !variant.preorder) return null;
    // gift variants carry a short date for the PDP line ("13 Nov"); the stamp uses the long form so every line reads the same
    return { _ff_preorder: variant.preorder_iso, 'Pre-order': 'Ships ' + (variant.preorder_label || variant.preorder) };
  }

  function selectedAddon() {
    return state.addon; // { el } — bundle variant resolved fresh in render()/addToCart()
  }

  function addonData(btn) {
    var script = btn.querySelector('[data-ff-addon-variants]');
    if (!script) return null; // block not linked to a bundle yet — preview only
    if (!btn._ffData) btn._ffData = JSON.parse(script.textContent);
    return btn._ffData;
  }

  function sizeAliases(btn) {
    var map = {};
    (btn.dataset.sizeMap || '').split('\n').forEach(function (line) {
      var parts = line.split('|');
      if (parts.length === 2) map[parts[0].trim()] = parts[1].trim();
    });
    return map;
  }

  /* The size to bundle/compare against: this product's own selected size, or
     (when the product has no Size option at all, e.g. the pillowcase) the
     merchant-configured default so a bundle size is still deterministic. */
  function effectiveSizes(btn) {
    var aliases = sizeAliases(btn);
    var base = state.size || btn.dataset.defaultSize || '';
    return [base, aliases[base]].filter(Boolean);
  }

  /* Match a variant by title against the selected colour + size, tolerating
     different size vocabularies (e.g. blanket "King/Super King" vs sheet "King").
     allowColourOnly: fall back to a colour-only match when the list's titles
     carry no size (e.g. pillowcases) — never allowed for the bundle itself,
     so a missing bundle size can't silently become a different size. */
  function matchByTitle(list, btn, requireAvailable, allowColourOnly) {
    if (!list || !list.length) return null;
    var sizes = effectiveSizes(btn);
    var pool = requireAvailable ? list.filter(function (v) { return v.available !== false; }) : list;
    var match = null;
    if (state.colour) {
      sizes.some(function (s) {
        match = pool.find(function (v) { return v.title.indexOf(state.colour) !== -1 && v.title.indexOf(s) !== -1; });
        return !!match;
      });
      if (!match && (allowColourOnly || !sizes.length)) {
        match = pool.find(function (v) { return v.title.indexOf(state.colour) !== -1; });
      }
    }
    return match || null;
  }

  function resolveBundle(btn) {
    var data = addonData(btn);
    if (!data) return null;
    return matchByTitle(data.bundle, btn, true, false);
  }

  function render() {
    var v = currentVariant();
    var addon = selectedAddon();
    var bundleV = addon ? resolveBundle(addon.el) : null;
    if (addon && !bundleV) {
      // selected bundle has no available variant for this colour/size — deselect
      state.addon = null;
      addon = null;
    }
    var total = bundleV ? bundleV.price : v ? v.price : 0;

    // option buttons
    root.querySelectorAll('[data-ff-option]').forEach(function (b) {
      var idx = b.dataset.optionIndex;
      var isColour = idx === String(colourIndex);
      var current = isColour ? state.colour : state.size;
      var on = b.dataset.value === current;
      b.classList.toggle('is-active', on);
      // selection was carried by class alone, so assistive tech could not tell what was chosen
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // gallery follows the chosen colour
    if (applyGalleryFilter && state.colour !== lastFilteredColour) {
      lastFilteredColour = state.colour;
      applyGalleryFilter(state.colour);
    }

    // colour labels
    var nameEl = root.querySelector('[data-ff-colour-name]');
    var noteEl = root.querySelector('[data-ff-colour-note]');
    if (nameEl) nameEl.textContent = state.colour || '';
    if (noteEl && colourIndex) {
      var activeSwatch = root.querySelector('.ff-pdp__swatch.is-active');
      var note = activeSwatch ? activeSwatch.dataset.note || '' : '';
      if (note && addon) note += ' Every piece in your set ships in this colour.';
      noteEl.textContent = note;
    }

    // compare-at: struck was-price + save chip while the variant is reduced.
    // Hidden whenever the bundle upgrade is selected (its own pricing shows),
    // and never shown on templates where the component-sum chip fires below
    // (that branch overwrites these with the provable bought-separately maths).
    var wasEl = root.querySelector('[data-ff-was]');
    var chip = root.querySelector('[data-ff-save-chip]');
    var hasSepMaths = !!root.querySelector('[data-ff-separately-data]');
    if (wasEl && chip) {
      if (!hasSepMaths && !bundleV && v && v.compare_at > v.price) {
        wasEl.textContent = money(v.compare_at);
        wasEl.hidden = false;
        chip.textContent = 'Save ' + money(v.compare_at - v.price);
        chip.hidden = false;
      } else {
        wasEl.hidden = true;
        chip.hidden = true;
      }
    }

    // price + afterpay
    var priceEl = root.querySelector('[data-ff-price]');
    var afterpayEl = root.querySelector('[data-ff-afterpay]');
    if (priceEl) priceEl.textContent = money(total);
    if (afterpayEl) afterpayEl.textContent = 'or 4 × ' + money(Math.round(total / 4)) + ' with Afterpay';

    // bundle product page: "$X bought separately" + dynamic save chip, from
    // the included products' real variant prices at the selected colour/size
    var sepScript = root.querySelector('[data-ff-separately-data]');
    if (sepScript && v) {
      if (!root._ffSepData) root._ffSepData = JSON.parse(sepScript.textContent);
      var sepBtn = { dataset: { sizeMap: root.dataset.sepSizeMap || '', defaultSize: '' } };
      var sepTotal = 0;
      var sepOk = true;
      root._ffSepData.comps.forEach(function (list) {
        if (!list.length) return; // unset picker — skip
        var m = matchByTitle(list, sepBtn, false, true);
        if (m) sepTotal += m.price;
        else sepOk = false;
      });
      var sepEl = root.querySelector('[data-ff-separately]');
      var chipEl = root.querySelector('[data-ff-save-chip]');
      if (sepOk && sepTotal > v.price) {
        if (sepEl) sepEl.textContent = ' · ' + money(sepTotal) + ' bought separately';
        if (chipEl) { chipEl.textContent = 'Save ' + money(sepTotal - v.price); chipEl.hidden = false; }
      } else {
        if (sepEl) sepEl.textContent = '';
      }
    }

    // addon rows: live +price and saving from real variant prices
    root.querySelectorAll('[data-ff-addon]').forEach(function (btn) {
      var on = addon && addon.el === btn;
      btn.classList.toggle('is-active', !!on);
      // the fake radio is aria-hidden, so this is the only cue AT gets
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var meta = btn.querySelector('[data-ff-addon-meta]');
      if (meta) {
        var bits = [];
        var sizeLabel = state.size || btn.dataset.defaultSize;
        if (sizeLabel) bits.push(sizeLabel);
        if (state.colour) bits.push(state.colour);
        meta.textContent = bits.join(' · ');
      }
      var data = addonData(btn);
      if (!data || !v) return; // preview row — keep the static labels
      var bv = matchByTitle(data.bundle, btn, true, false);
      var priceEl = btn.querySelector('[data-ff-addon-price]');
      var saveEl = btn.querySelector('[data-ff-addon-save]');
      if (!bv) {
        btn.classList.add('is-unavailable');
        if (priceEl) priceEl.textContent = '\u2013';
        if (saveEl) saveEl.hidden = true;
        return;
      }
      btn.classList.remove('is-unavailable');
      var extra = bv.price - v.price;
      if (priceEl) priceEl.textContent = '+' + money(extra);
      if (saveEl) {
        var c1 = matchByTitle(data.comp1, btn, false, true);
        var c2 = matchByTitle(data.comp2, btn, false, true);
        if (c1 && c2) {
          var save = c1.price + c2.price - extra;
          if (save > 0) {
            saveEl.textContent = 'Save ' + money(save);
            saveEl.hidden = false;
          } else {
            saveEl.hidden = true;
          }
        }
      }
    });
    var clear = root.querySelector('[data-ff-addon-clear]');
    if (clear) clear.hidden = !addon;

    // Pre-order: the selected variant (or the bundle that contains it) has sold
    // through and is set to keep selling. The panel, button label and stock bar
    // change only for that selection; every in-stock variant looks as before.
    var poDate = v && v.available ? (v.preorder || (bundleV && bundleV.preorder) || '') : '';
    var poPanel = root.querySelector('[data-ff-preorder]');
    if (poPanel) {
      poPanel.hidden = !poDate;
      if (poDate) {
        poPanel.querySelectorAll('[data-ff-preorder-date]').forEach(function (el) { el.textContent = poDate; });
        var poStatus = poPanel.querySelector('[data-ff-preorder-status]');
        var pct = parseInt(v.preorder_pct, 10);
        if (poStatus) poStatus.textContent = pct >= 1 ? pct + '% reserved' : 'Reserving now';
        var poBar = poPanel.querySelector('[data-ff-preorder-bar]');
        if (poBar) {
          poBar.hidden = !(pct >= 1);
          poBar.firstElementChild.style.width = Math.min(100, Math.max(0, pct || 0)) + '%';
        }
      }
      // Earlier shipments already fully reserved: one muted row each, cloned
      // from the hidden template row (several SKUs ship in batches since Oct 2026).
      var pastTpl = poPanel.querySelector('[data-ff-preorder-past]');
      if (pastTpl) {
        poPanel.querySelectorAll('[data-ff-preorder-past-clone]').forEach(function (el) { el.remove(); });
        var pastDates = poDate && v.preorder_past ? String(v.preorder_past).split(',') : [];
        pastDates.forEach(function (d) {
          d = d.trim();
          if (!d) return;
          var row = pastTpl.cloneNode(true);
          row.removeAttribute('data-ff-preorder-past');
          row.setAttribute('data-ff-preorder-past-clone', '');
          row.hidden = false;
          row.querySelector('[data-ff-preorder-past-date]').textContent = d;
          pastTpl.parentNode.insertBefore(row, pastTpl);
        });
      }
    }
    // "In stock" must only show while it is true
    var stockBar = root.querySelector('[data-ff-stock]');
    if (stockBar) stockBar.hidden = !v || !v.available || !!poDate;

    // Free gift on pre-order while the blanket itself is in stock: one plain
    // line under the gift box naming the colour and the date. Hidden when the
    // blanket is on pre-order (its panel states the date), when the bundle
    // upgrade is selected (it brings its own pillowcases) or when the matching
    // pillowcases are in stock. The gift pick mirrors the add-to-cart pick below.
    var followEl = root.querySelector('[data-ff-gift-follow]');
    if (followEl) {
      var followGift = null;
      var followSrc = root.querySelector('[data-ff-gift-variants]');
      if (followSrc && v && v.available && !poDate && !bundleV) {
        try {
          var fgift = JSON.parse(followSrc.textContent);
          var fpool = fgift.variants.filter(function (g) { return g.available; });
          followGift =
            (state.colour && fpool.find(function (g) { return g.title.indexOf(state.colour) !== -1; })) ||
            fpool.find(function (g) { return g.title.indexOf(fgift.fallback) !== -1; }) ||
            fpool[0] || null;
        } catch (e) { followGift = null; }
      }
      var followOn = !!(followGift && followGift.preorder);
      followEl.hidden = !followOn;
      if (followOn) {
        var fc = followEl.querySelector('[data-ff-gift-follow-colour]');
        var fd = followEl.querySelector('[data-ff-gift-follow-date]');
        if (fc) fc.textContent = followGift.colour || followGift.title;
        if (fd) fd.textContent = followGift.preorder;
      }
    }

    // ATC + sticky
    var label = root.querySelector('[data-ff-atc-label]');
    var atc = root.querySelector('[data-ff-atc]');
    if (label) {
      label.textContent = v && !v.available
        ? 'Sold out'
        : (poDate ? 'Pre-order' : 'Add to Cart') + ' \u00b7 ' + money(total);
    }
    if (atc) atc.disabled = !v || !v.available;
    var mirrorBtn = root.querySelector('[data-ff-atc-mirror]');
    if (mirrorBtn) mirrorBtn.textContent = poDate ? 'Pre-order' : 'Add to cart';
    var sv = root.querySelector('[data-ff-sticky-variant]');
    var sp = root.querySelector('[data-ff-sticky-price]');
    if (sv) sv.textContent = [state.colour, state.size].filter(Boolean).join(' · ');
    if (sp) sp.textContent = money(total);
    // With the bundle upgrade selected the ATC adds the BUNDLE product, so the
    // sticky bar must say so — price and variant already reflect it, and a
    // mismatched title reads as adding the wrong item.
    var st = root.querySelector('[data-ff-sticky-title]');
    if (st) {
      var bt = addon && addon.el.dataset.bundleTitle;
      st.textContent = bt || st.dataset.baseTitle;
    }

    // deep-linkable variant URL
    if (v && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  // option clicks
  root.querySelectorAll('[data-ff-option]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (b.dataset.optionIndex === String(colourIndex)) state.colour = b.dataset.value;
      else state.size = b.dataset.value;
      render();
    });
  });

  // addon toggle
  root.querySelectorAll('[data-ff-addon]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (state.addon && state.addon.el === btn) {
        state.addon = null;
      } else {
        if (!resolveBundle(btn)) return; // preview-only row or no matching bundle variant
        state.addon = { el: btn };
      }
      render();
    });
  });
  var clearBtn = root.querySelector('[data-ff-addon-clear]');
  if (clearBtn) clearBtn.addEventListener('click', function () { state.addon = null; render(); });

  // add to cart — with the bundle-upgrade selected, the BUNDLE variant is added
  // instead of the base product (Simple Bundles expands it for fulfilment)
  var adding = false;
  var noteTimer = null;
  function addToCart() {
    var v = currentVariant();
    if (!v || !v.available || adding) return;
    var addon = selectedAddon();
    var bundleV = addon ? resolveBundle(addon.el) : null;
    adding = true;
    var mainV = bundleV || v;
    var mainLine = { id: mainV.id, quantity: 1 };
    var mainPo = preorderProps(mainV);
    if (mainPo) mainLine.properties = mainPo;
    var items = [mainLine];

    // Free-gift auto-add: colour-matched pillowcases ride along with a plain
    // blanket add (never with the bundle upgrade — the bundle already has them).
    // Best-effort by design: if this misses, the cart drawer banner offers the
    // gift one-click instead.
    var giftEl = root.querySelector('[data-ff-gift-variants]');
    if (!bundleV && giftEl) {
      try {
        var gift = JSON.parse(giftEl.textContent);
        var pool = gift.variants.filter(function (g) { return g.available; });
        var gv =
          (state.colour &&
            pool.find(function (g) { return g.title.indexOf(state.colour) !== -1; })) ||
          pool.find(function (g) { return g.title.indexOf(gift.fallback) !== -1; }) ||
          pool[0];
        // _ff_gift marks the line as the auto-added gift (hidden property, "_"
        // prefix): ff-cart-guard uses it to remove orphaned gifts when the last
        // blanket leaves the cart — without it, an orphan is indistinguishable
        // from a pillowcase the shopper chose to buy at $59.
        if (gv) {
          var giftLine = { id: gv.id, quantity: 1, properties: { _ff_gift: '1' } };
          // The blanket decides (owner rule, 22 Oct 2026): a pre-order blanket
          // holds the whole order, so the gift carries the BLANKET's batch. Only
          // when the blanket is in stock does a pre-order gift keep its own date
          // ("blanket ships now, pillowcases follow").
          var giftPo = mainPo || preorderProps(gv);
          if (giftPo) {
            giftLine.properties._ff_preorder = giftPo._ff_preorder;
            giftLine.properties['Pre-order'] = giftPo['Pre-order'];
          }
          items.push(giftLine);
        }
      } catch (e) {
        /* gift stays best-effort */
      }
    }

    var drawer = document.querySelector('cart-drawer');
    function postItems(list) {
      var body = { items: list };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    postItems(items)
      .then(function (res) {
        // A multi-item add fails wholesale if any line can't be added, so retry
        // the main product alone rather than losing the sale to the gift.
        if (res.status && items.length > 1) return postItems(items.slice(0, 1));
        return res;
      })
      .then(function (res) {
        if (res.status) throw res;
        var note = root.querySelector('[data-ff-added]');
        if (note) {
          note.hidden = false;
          var what = [state.colour, state.size].filter(Boolean).join(' · ');
          if (bundleV && addon) {
            var titleEl = addon.el.querySelector('.ff-pdp__addon-title');
            what = (titleEl ? titleEl.textContent + ' · ' : '') + what;
          }
          note.textContent = what + ' added to your cart';
          // clear the previous timer, or a second add within 2.6s hides its own confirmation early
          clearTimeout(noteTimer);
          noteTimer = setTimeout(function () { note.hidden = true; }, 2600);
        }
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else if (drawer && window.customElements && customElements.whenDefined) {
          // Slow phones: deferred cart.js may not have upgraded the drawer yet
          // when a fast shopper hits Add. Waiting beats bouncing to /cart —
          // that navigation WAS the mobile "took me straight to cart page" bug.
          // res carries no sections here (they're only requested once the
          // drawer is upgraded), so re-fetch the drawer instead of rendering.
          customElements.whenDefined('cart-drawer').then(function () {
            var items = document.querySelector('cart-drawer-items');
            drawer.classList.remove('is-empty');
            var synced = items && items.onCartUpdate ? items.onCartUpdate() : Promise.resolve();
            Promise.resolve(synced).then(function () {
              if (typeof drawer.open === 'function') drawer.open();
            });
          });
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function () {
        // Add genuinely failed (sold out, 422): re-sync the drawer in place so
        // it shows the true cart. Never navigate mid-interaction.
        var items = document.querySelector('cart-drawer-items');
        if (items && items.onCartUpdate) items.onCartUpdate();
        else if (!drawer) window.location.href = window.Shopify.routes.root + 'cart';
      })
      .finally(function () { adding = false; });
  }
  var atcBtn = root.querySelector('[data-ff-atc]');
  if (atcBtn) atcBtn.addEventListener('click', addToCart);
  var mirror = root.querySelector('[data-ff-atc-mirror]');
  if (mirror) mirror.addEventListener('click', addToCart);

  // sticky bar visibility
  var sticky = root.querySelector('[data-ff-sticky]');
  if (sticky) {
    // hoisted: these never change, and querying them per scroll event forced a layout read each time
    var buyGrid = root.querySelector('.ff-pdp__grid');
    var foot = document.querySelector('.ff-footer');
    var stickyTick = false;
    var onScroll = function () {
      if (stickyTick) return;
      stickyTick = true;
      requestAnimationFrame(function () {
        stickyTick = false;
        if (!buyGrid) return;
        var buyBottom = buyGrid.getBoundingClientRect().bottom;
        var atFooter = foot ? foot.getBoundingClientRect().top < window.innerHeight - 60 : false;
        sticky.hidden = !(buyBottom < 80 && !atFooter);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // size guide drawer
  var guide = root.querySelector('[data-ff-guide]');
  var scrim = root.querySelector('[data-ff-guide-scrim]');
  var guideOpener = null;
  function setGuide(open) {
    if (!guide) return;
    if (open) {
      // Lock scroll, but pad for the scrollbar that disappears with it —
      // otherwise the whole page shifts sideways as the drawer opens.
      var sw = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.overflow = 'hidden';
      if (sw > 0) document.documentElement.style.paddingRight = sw + 'px';
      guide.hidden = false;
      scrim.hidden = false;
      void guide.offsetWidth; // flush styles so the slide-in actually transitions
      guide.classList.add('is-open');
      scrim.classList.add('is-open');
      guideOpener = document.activeElement;
      var closeBtn = guide.querySelector('[data-ff-close-guide]');
      if (closeBtn) closeBtn.focus();
    } else {
      guide.classList.remove('is-open');
      scrim.classList.remove('is-open');
      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        guide.hidden = true;
        scrim.hidden = true;
        document.documentElement.style.overflow = '';
        document.documentElement.style.paddingRight = '';
      };
      guide.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 420); // fallback: reduced-motion or a missed event
      if (guideOpener && guideOpener.focus) {
        guideOpener.focus();
        guideOpener = null;
      }
    }
  }
  var openGuide = root.querySelector('[data-ff-open-guide]');
  if (openGuide) openGuide.addEventListener('click', function () { setGuide(true); });
  var closeGuide = root.querySelector('[data-ff-close-guide]');
  if (closeGuide) closeGuide.addEventListener('click', function () { setGuide(false); });
  if (scrim) scrim.addEventListener('click', function () { setGuide(false); });
  // Close on any press outside the panel — nobody should have to reach the X.
  document.addEventListener('pointerdown', function (e) {
    if (!guide || guide.hidden) return;
    if (guide.contains(e.target)) return;
    if (openGuide && openGuide.contains(e.target)) return;
    setGuide(false);
  });
  document.addEventListener('keydown', function (e) {
    if (!guide || guide.hidden) return;
    if (e.key === 'Escape') { setGuide(false); return; }
    // aria-modal hides the rest of the page from AT, so Tab must stay inside the dialog
    if (e.key !== 'Tab') return;
    var f = [].slice.call(guide.querySelectorAll('a[href], button:not([disabled])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // set by the gallery module below; render() calls it when the colour changes
  var applyGalleryFilter = null;
  var lastFilteredColour;

  // gallery: scroll-snap track, arrows, position rail, colour filtering
  (function () {
    var gallery = root.querySelector('[data-ff-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-ff-gallery-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.ff-pdp__slide'));
    if (slides.length < 2) return;
    // shown = the slides currently in play; colour filtering narrows this list
    var shown = slides.slice();

    var prevBtn = gallery.querySelector('[data-ff-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-ff-gallery-next]');
    var railThumb = gallery.querySelector('[data-ff-gallery-thumb]');
    var counter = gallery.querySelector('[data-ff-gallery-counter]');
    var bar = gallery.querySelector('[data-ff-gallery-bar]');
    var jumps = gallery.querySelectorAll('[data-ff-gallery-jump]');
    var scroller = gallery.querySelector('[data-ff-gallery-scroller]');
    var motionOk = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    // pending = the slide a smooth scroll is heading for, so rapid arrow
    // clicks step on from the intended slide rather than the in-flight position
    var pending = null;
    var pendingTimer = null;

    function current() {
      var w = track.clientWidth;
      return w ? Math.round(track.scrollLeft / w) : 0;
    }

    function goTo(i) {
      var target = Math.max(0, Math.min(shown.length - 1, i));
      pending = target;
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function () { pending = null; }, 700);
      track.scrollTo({ left: target * track.clientWidth, behavior: motionOk ? 'smooth' : 'auto' });
      sync();
    }

    // The rail mirrors how far the gallery column itself has been scrolled,
    // so it spans the hero and every thumbnail row beneath it.
    function syncRail() {
      if (!railThumb || !railThumb.parentNode || !scroller) return;
      var railH = railThumb.parentNode.clientHeight;
      var visible = scroller.clientHeight;
      var total = scroller.scrollHeight;
      if (!railH || !total) return;
      // px math, not %: a min-height floor on the thumb would desync percentage travel
      var thumbH = Math.max(24, Math.min(railH, railH * (visible / total)));
      var travel = Math.max(0, railH - thumbH);
      var maxScroll = Math.max(0, total - visible);
      var progress = maxScroll ? scroller.scrollTop / maxScroll : 0;
      railThumb.style.height = thumbH + 'px';
      railThumb.style.transform = 'translateY(' + (progress * travel) + 'px)';
    }

    function sync() {
      var at = current();
      if (pending !== null && at === pending) { pending = null; clearTimeout(pendingTimer); }
      var i = pending === null ? at : pending;
      syncRail();
      var atSlide = shown[i];
      if (counter) counter.textContent = (i + 1) + ' / ' + shown.length;
      if (bar) {
        var seg = shown.length ? 100 / shown.length : 100;
        bar.style.width = seg + '%';
        bar.style.transform = 'translateX(' + (i * 100) + '%)';
      }
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= shown.length - 1;
      for (var j = 0; j < jumps.length; j++) {
        jumps[j].classList.toggle('is-active', !!atSlide && jumps[j].dataset.ffIdx === atSlide.dataset.ffIdx);
      }
    }

    // ── colour filtering ──────────────────────────────────────────────
    // Image alt text carries the colour as its last words, e.g.
    // "Soothing muslin blanket in Snow White" (migrated 8 Aug 2026 from the old
    // machine tags "ecomposer-colour-snow-white" — descriptive alts serve SEO and
    // screen readers while still driving the swatch→gallery filter).
    // Alt text is handleized, so colour names are whole hyphen-delimited tokens.
    // Matching on tokens rather than raw substrings keeps descriptive alt text safe:
    // "a rustic timber bed" must not register as Rust, and "on white linen" must not
    // register as Snow White.
    // RULE for new images: name exactly ONE colour per alt, spelled as the swatch is
    // ("Snow White", "Light Grey", "Sage Green"), or none to show it in every colour.
    function hasToken(alt, handle) {
      return ('-' + alt + '-').indexOf('-' + handle + '-') !== -1;
    }

    function altMatches(alt, handle) {
      if (!alt || !handle) return false;
      if (hasToken(alt, handle)) return true;
      // Legacy EComposer tags spell Snow White as bare "white". Trust that only inside
      // a machine tag — in prose, "white" describes the sheets, not the blanket.
      if (
        handle === 'snow-white' &&
        alt.indexOf('ecomposer-colour-') === 0 &&
        hasToken(alt, 'white')
      ) {
        return true;
      }
      return false;
    }

    function handleize(s) {
      return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    }

    applyGalleryFilter = function (colour) {
      var handle = colour ? handleize(colour) : '';
      var match = handle
        ? slides.filter(function (s) { return altMatches(s.dataset.ffMalt, handle); })
        : [];
      // never leave the gallery empty: an untagged product falls back to everything
      var next = match.length ? match : slides;
      if (next.length === shown.length && next[0] === shown[0]) return;
      shown = next;

      slides.forEach(function (s) { s.hidden = shown.indexOf(s) === -1; });
      for (var j = 0; j < jumps.length; j++) {
        var idx = jumps[j].dataset.ffIdx;
        var on = shown.some(function (s) { return s.dataset.ffIdx === idx; });
        jumps[j].hidden = !on;
      }
      pending = null;
      clearTimeout(pendingTimer);
      track.scrollTo({ left: 0, behavior: 'auto' });
      if (scroller) scroller.scrollTop = 0;
      sync();
    };

    function base() { return pending === null ? current() : pending; }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(base() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(base() + 1); });
    function posOfIdx(idx) {
      for (var n = 0; n < shown.length; n++) {
        if (shown[n].dataset.ffIdx === idx) return n;
      }
      return -1;
    }

    for (var k = 0; k < jumps.length; k++) {
      jumps[k].addEventListener('click', function (e) {
        var pos = posOfIdx(e.currentTarget.dataset.ffIdx);
        if (pos < 0) return;
        goTo(pos);
        // keep the hero in step, then show the full-size view
        if (scroller) scroller.scrollTo({ top: 0, behavior: 'auto' });
        openLightbox(pos);
      });
    }

    // ── full-screen viewer ────────────────────────────────────────────
    var lb = root.querySelector('[data-ff-lightbox]');
    var lbImg = lb && lb.querySelector('[data-ff-lb-img]');
    var lbPrev = lb && lb.querySelector('[data-ff-lb-prev]');
    var lbNext = lb && lb.querySelector('[data-ff-lb-next]');
    var lbCount = lb && lb.querySelector('[data-ff-lb-count]');
    var lbPanel = lb && lb.querySelector('.ff-lightbox__panel');
    var lbPos = 0;
    var lbOpener = null;

    function showLightbox(pos) {
      if (!lb || !shown.length) return;
      lbPos = Math.max(0, Math.min(shown.length - 1, pos));
      var slide = shown[lbPos];
      lbImg.src = slide.dataset.ffFull || '';
      lbImg.alt = slide.dataset.ffAlt || '';
      // carry the real aspect ratio across so the panel doesn't jump before load
      var inline = slide.querySelector('img');
      if (inline && inline.naturalWidth) {
        lbImg.width = inline.naturalWidth;
        lbImg.height = inline.naturalHeight;
      }
      if (lbCount) lbCount.textContent = (lbPos + 1) + ' / ' + shown.length;
      if (lbPrev) lbPrev.disabled = lbPos <= 0;
      if (lbNext) lbNext.disabled = lbPos >= shown.length - 1;
    }

    function openLightbox(pos) {
      if (!lb) return;
      lbOpener = document.activeElement;
      showLightbox(pos);
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = lb.querySelector('button[data-ff-lb-close]');
      if (closeBtn && closeBtn.focus) closeBtn.focus();
    }

    function closeLightbox() {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      // keep the inline gallery on whatever was last viewed
      goTo(lbPos);
      if (lbOpener && lbOpener.focus) lbOpener.focus();
      lbOpener = null;
    }

    if (lb) {
      lb.querySelectorAll('[data-ff-lb-close]').forEach(function (b) {
        b.addEventListener('click', closeLightbox);
      });
      if (lbPrev) lbPrev.addEventListener('click', function () { showLightbox(lbPos - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { showLightbox(lbPos + 1); });

      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') { closeLightbox(); return; }
        if (e.key === 'ArrowLeft') { showLightbox(lbPos - 1); return; }
        if (e.key === 'ArrowRight') { showLightbox(lbPos + 1); return; }
        if (e.key !== 'Tab' || !lbPanel) return;
        // keep tabbing inside the dialog while it is open
        var focusable = [].slice.call(lbPanel.querySelectorAll('button:not([disabled])'));
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      // clicking the main image opens it full size
      track.addEventListener('click', function (e) {
        var slide = e.target.closest ? e.target.closest('.ff-pdp__slide') : null;
        if (!slide || slide.hidden) return;
        var pos = posOfIdx(slide.dataset.ffIdx);
        if (pos >= 0) openLightbox(pos);
      });
    }

    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { sync(); ticking = false; });
    }

    track.addEventListener('scroll', schedule, { passive: true });
    if (scroller) scroller.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    // lazy thumbnails change the scroll height as they arrive — keep the rail honest
    if (scroller && 'ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(scroller);
    }
    if (scroller) {
      scroller.addEventListener('load', schedule, true);
    }

    sync();
  })();

  render();
})();
